export default {
  title: "Additional Info",
  edit_info: "Edit Info",
  title_placeholder_empty: "No additional info available",
};
